import { getCookie } from "./trainUtils";

export const getMMTAuth = () => {
  try {
    return getCookie('mmt-auth');
  } catch {
    console.error('mmtaut not found.')
    return null;
  }
}

export const getDeviceId = () => {
  try {
    return getCookie('dvid');
  } catch (e) {
    console.error('Device Id not found.')
    return 'rails-dweb';
  }
}
